import { render, staticRenderFns } from "./all-employees.vue?vue&type=template&id=22af6a52"
import script from "./all-employees.vue?vue&type=script&lang=js"
export * from "./all-employees.vue?vue&type=script&lang=js"
import style0 from "./all-employees.vue?vue&type=style&index=0&id=22af6a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports